'use strict'

module.exports = [
	{dir: 'src', name: 'article-header'},
	{dir: 'src', name: 'article'},
	{dir: 'data', name: 'article-event'},
]



//////////////////
// WEBPACK FOOTER
// ./data/portal2/templates/_index.js
// module id = 278
// module chunks = 0